<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 22 22"
    :fill="filled ? 'currentColor' : 'none'"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="square"
    stroke-linejoin="miter"
    class="alice-icon"
    aria-hidden="true"
  >
    <path v-if="name === 'folder'" d="M2 5h6l2 2h10v11H2z" />
    <template v-else-if="name === 'users'">
      <circle cx="8" cy="8" r="3.5" />
      <circle cx="15.5" cy="9" r="2.5" />
      <path d="M2 19c0-3 2.7-5 6-5s6 2 6 5M14 19c0-2 1.7-4 4-4s2 2 2 4" />
    </template>
    <path
      v-else-if="name === 'wrench'"
      d="M14 3a4 4 0 0 0-4 5l-7 7 3 3 7-7a4 4 0 0 0 5-4l-3 1-2-2 1-3z"
    />
    <path
      v-else-if="name === 'dollar'"
      d="M11 2v18M15 6c-1-1.3-2.3-2-4-2-2.3 0-4 1.3-4 3.5S8.5 11 11 11s4 1 4 3.5S13.3 18 11 18c-2 0-3.5-.8-4.5-2"
    />
    <path
      v-else-if="name === 'shield'"
      d="M11 2 3 5v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V5z"
    />
    <template v-else-if="name === 'leaf'">
      <path d="M18 4C10 4 4 9 4 16c0 1 .3 2 1 2 5 0 13-3 13-14z" />
      <path d="M5 17C8 12 12 9 16 6" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="9.5" cy="9.5" r="6" />
      <path d="m14 14 5 5" />
    </template>
    <path v-else-if="name === 'plus'" d="M11 4v14M4 11h14" />
    <path v-else-if="name === 'arrow-right'" d="M4 11h14M12 5l6 6-6 6" />
    <path v-else-if="name === 'chevron-down'" d="m4 8 7 7 7-7" />
    <path v-else-if="name === 'chevron-right'" d="m8 4 7 7-7 7" />
    <path v-else-if="name === 'chevron-left'" d="m14 4-7 7 7 7" />
    <path
      v-else-if="name === 'layers'"
      d="m11 3-8 4 8 4 8-4zM3 11l8 4 8-4M3 15l8 4 8-4"
    />
    <template v-else-if="name === 'lock'">
      <path d="M5 10h12v9H5z" />
      <path d="M8 10V7a3 3 0 0 1 6 0v3" />
    </template>
    <path
      v-else-if="name === 'trash'"
      d="M4 6h14M9 3h4M6 6l1 13h8l1-13M9 9v8M13 9v8"
    />
    <path v-else-if="name === 'filter'" d="M3 5h16l-6 7v6l-4 2v-8z" />
    <path
      v-else-if="name === 'sort'"
      d="M6 4v14M3 7l3-3 3 3M16 18V4M19 15l-3 3-3-3"
    />
    <template v-else-if="name === 'more'">
      <circle cx="5" cy="11" r="1" />
      <circle cx="11" cy="11" r="1" />
      <circle cx="17" cy="11" r="1" />
    </template>
    <path
      v-else-if="name === 'grid'"
      d="M3 3h7v7H3zM12 3h7v7h-7zM3 12h7v7H3zM12 12h7v7h-7z"
    />
    <path v-else-if="name === 'rows'" d="M3 4h16M3 11h16M3 18h16" />
    <path
      v-else-if="name === 'star'"
      d="m11 3 2.6 5.3 5.9.9-4.3 4.1 1 5.7L11 16.3 5.7 19l1-5.7-4.3-4.1 5.9-.9z"
    />
    <path
      v-else-if="name === 'external'"
      d="M10 4H4v14h14v-6M14 4h6v6M10 12 20 4"
    />
    <path
      v-else-if="name === 'paperclip'"
      d="M16 7 9 14a3 3 0 0 0 4 4l7-7a5 5 0 0 0-7-7L5 11a7 7 0 0 0 10 10l5-5"
    />
    <path v-else-if="name === 'file'" d="M5 3h8l5 5v11H5zM13 3v5h5" />
    <template v-else-if="name === 'image'">
      <path d="M3 4h16v14H3z" />
      <circle cx="8" cy="9" r="1.5" />
      <path d="m4 16 4-4 4 4 3-3 4 4" />
    </template>
    <template v-else-if="name === 'copy'">
      <path d="M8 8h10v10H8z" />
      <path d="M4 14V4h10" />
    </template>
    <path v-else-if="name === 'bookmark'" d="M5 3h12v16l-6-4-6 4z" />
    <path v-else-if="name === 'pencil'" d="M14 4l4 4L8 18H4v-4z" />
    <path
      v-else-if="name === 'book'"
      d="M4 4h6a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H4zM20 4h-6a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h6z"
    />
    <template v-else-if="name === 'lightbulb'">
      <path
        d="M11 3a5.5 5.5 0 0 0-3 10.1c.9.6 1.5 1.4 1.5 2.4h3c0-1 .6-1.8 1.5-2.4A5.5 5.5 0 0 0 11 3z"
      />
      <path d="M9 18.5h4M9.5 21h3" />
    </template>
    <template v-else-if="name === 'mic'">
      <rect x="8" y="2" width="6" height="11" rx="3" />
      <path d="M4.5 10a6.5 6.5 0 0 0 13 0M11 16.5V20M7.5 20h7" />
    </template>
    <path v-else-if="name === 'stop'" d="M6 6h10v10H6z" />
    <template v-else-if="name === 'video'">
      <path d="M2 5h11v12H2z" />
      <path d="m13 10 7-4v10l-7-4z" />
    </template>
    <path v-else-if="name === 'play'" d="m7 4 11 7-11 7z" />
    <path
      v-else-if="name === 'download'"
      d="M11 3v10M7 9l4 4 4-4M4 15v4h14v-4"
    />
    <path v-else-if="name === 'pause'" d="M7 5h3v12H7zM12 5h3v12h-3z" />
    <path v-else-if="name === 'close'" d="M5 5l12 12M17 5 5 17" />
    <template v-else-if="name === 'bell'">
      <path d="M6 15V9.5a5 5 0 0 1 10 0V15l1.5 2h-13z" />
      <path d="M9 19.5h4" />
    </template>
    <template v-else-if="name === 'bell-off'">
      <path d="M6 15V9.5a5 5 0 0 1 10 0V15l1.5 2h-13z" />
      <path d="M9 19.5h4M3 3l16 16" />
    </template>
    <path
      v-else-if="name === 'plug'"
      d="M8 2v5M14 2v5M5 7h12v4a6 6 0 0 1-12 0zM11 17v4"
    />
  </svg>
</template>

<script>
export default {
  name: "AliceIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 22 },
    filled: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.alice-icon {
  display: inline-block;
  flex-shrink: 0;
}
</style>
